import React from 'react';
import { motion } from 'framer-motion';

const PaymentOptions = ({ 
  subtotal, 
  paymentMethod, 
  setPaymentMethod, 
  submitOrder, 
  loading,
  cartItems
}) => {
  return (
    <div className="col-md-4">
      <div className="border-top pt-3 d-flex justify-content-between fw-bold fs-5">
        <span>Subtotal:</span>
        <span>${subtotal.toFixed(2)}</span>
      </div>

      <div className="alert alert-warning mt-3">
        <strong>Notice:</strong> Currently only WhatsApp orders are available. Other payment methods will be back soon.
      </div>

      <div className="mt-3">
        <div className="form-check mb-2">
          <input 
            className="form-check-input" 
            type="radio" 
            name="paymentMethod" 
            value="whatsapp" 
            checked={paymentMethod === 'whatsapp'} 
            onChange={() => setPaymentMethod('whatsapp')} 
          />
          <label className="form-check-label">Order via WhatsApp</label>
        </div>
        <div className="form-check mb-2">
          <input 
            className="form-check-input" 
            type="radio" 
            name="paymentMethod" 
            value="paynow" 
            checked={paymentMethod === 'paynow'} 
            onChange={() => setPaymentMethod('paynow')}
            disabled
          />
          <label className="form-check-label text-muted">Pay with PayNow (Temporarily Unavailable)</label>
        </div>
        <div className="form-check">
          <input 
            className="form-check-input" 
            type="radio" 
            name="paymentMethod" 
            value="paypal" 
            checked={paymentMethod === 'paypal'} 
            onChange={() => setPaymentMethod('paypal')}
            disabled
          />
          <label className="form-check-label text-muted">Pay with PayPal (Temporarily Unavailable)</label>
        </div>
      </div>

      {paymentMethod === 'whatsapp' && (
        <motion.button
          className="btn btn-success w-100 mt-3"
          onClick={() => submitOrder(false)}
          disabled={loading}
          whileTap={{ scale: 0.95 }}
          whileHover={{ scale: 1.02 }}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Sending Order...
            </>
          ) : (
            '📩 Send Order via WhatsApp'
          )}
        </motion.button>
      )}

      {paymentMethod === 'paynow' && (
        <div className="alert alert-info mt-3">
          PayNow is temporarily unavailable. Please order via WhatsApp instead.
        </div>
      )}

      {paymentMethod === 'paypal' && (
        <div className="alert alert-info mt-3">
          PayPal is temporarily unavailable. Please order via WhatsApp instead.
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;